<template>

  <ion-action-sheet
        :is-open="isOpen"
        :header="props.heading"
        class="my-custom-class"
        :buttons="props.items"
        @didDismiss="processDismiss($event)"
        >
  </ion-action-sheet> 
</template>
  
<script setup>

  import { IonActionSheet, modalController } from '@ionic/vue';

  import { ref } from "vue"
  import { watch } from "vue";
  import { computed } from "@vue/reactivity"

  const emit = defineEmits(['action-sheet-result'])

  const props = defineProps({
    heading : String,
    items : Array,
    trigger : Number
  })
  
  const trigger = computed({ get() { return props.trigger } })

  const isOpen = ref(false);

  watch(trigger, (newVal,oldVal) => {
    //console.log("**** action sheet trigger",newVal)
    isOpen.value = true
  })

  const processDismiss = (ev) => {
    //console.log(JSON.stringify(ev.detail, null, 2));
    isOpen.value = false
    if (ev.detail.role != undefined) {
      //console.log("Action got cancelled")
      emit('action-sheet-result','no')
      return
    }
    if (ev.detail.data == undefined) {
      emit('action-sheet-result','nodata')
      return
    }
    //console.log("Action index is: ",ev.detail.data.index)
    emit('action-sheet-result','yes',ev.detail.data.index)
  };

</script>

<style scoped>

</style>